import { render } from "./DataCaculate.vue?vue&type=template&id=63eca5b2&scoped=true"
import script from "./DataCaculate.vue?vue&type=script&lang=js"
export * from "./DataCaculate.vue?vue&type=script&lang=js"

import "./DataCaculate.vue?vue&type=style&index=0&id=63eca5b2&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eca5b2"]])

export default __exports__